<form [formGroup]="savingsForm()">
  <h2>Min ekonomi - Sparande</h2>
  <p>Hur stort är ditt totala sparade kapital i andra banker/institut?</p>

  @if (routeService.onHorseRoute()) {

    <mat-form-field [class.small-screen]="orientationService.isSmallScreen()">
      <mat-label>Totalt sparat kapital i SEK</mat-label>
      <mat-select
        placeholder="Sparat kapital i SEK"
        formControlName="savingsTotal">
        @for (interval of savingsIntervals; track interval) {
          <mat-option [value]="interval">{{ interval }}</mat-option>
        }
      </mat-select>

      @if (savingsForm().get('savingsTotal')?.invalid && savingsForm().get('savingsTotal')?.touched) {
        <mat-icon matIconSuffix aria-hidden="true">
          priority_high
        </mat-icon>
      }

      @if (savingsForm().get('savingsTotal')?.touched) {
        <mat-error>
          Vänligen gör ett val
        </mat-error>
      }
    </mat-form-field>

  } @else {

    <mat-form-field [class.small-screen]="orientationService.isSmallScreen()">
      <mat-label>Totalt sparat kapital i SEK</mat-label>
      <input
        placeholder="Sparat kapital i SEK"
        tabindex="0"
        inputmode="numeric"
        maxlength="19"
        matInput formControlName="savingsTotal" spbFormatNumber
      >

      @if (savingsForm().get('savingsTotal')?.invalid && savingsForm().get('savingsTotal')?.touched) {
        <mat-icon matIconSuffix aria-hidden="true">
          priority_high
        </mat-icon>
      }

      @if (savingsForm().get('savingsTotal')?.touched) {
        <mat-error>
          Vänligen ange ett belopp
        </mat-error>
      }
    </mat-form-field>
  }

  <div
    [class.selection-error]="savingsForm().get('savingsSource')?.invalid && savingsForm().get('savingsSource')?.touched">
    <div class="margin-bottom-medium column">
      <p class="select-title">Var kommer ditt sparade kapital ifrån?</p>
      @for (option of savingsAccountService.savingsSource; track $index) {
        <div class="margin-bottom-small"
             [class.small-screen]="orientationService.isSmallScreen()">
          <mat-checkbox
            tabindex="0"
            #checkbox
            [checked]="option.checked"
            (change)="onCheckboxChange($index, $event.checked)"
            (keydown.enter)="onCheckboxChange($index, !savingsAccountService.savingsSource[$index].checked); checkbox.toggle(); $event.preventDefault()">
            {{ option.value }}
          </mat-checkbox>
        </div>
      }
      @if (savingsForm().get('savingsSource')?.invalid && savingsForm().get('savingsSource')?.touched) {
        <mat-error class="checkbox-error">
          Vänligen välj minst ett alternativ
        </mat-error>
      }
    </div>
  </div>
</form>
